/* トップページ専用（実績スライダーは common.js の .cmn-slider） */

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector("#sec-solution");
  if (section) {
  const tabs = section.querySelectorAll(".topSolution__tab");
  const panel = section.querySelector(".topSolution__content");
  const problem = section.querySelector(".topSolution__problem");
  const list = section.querySelector(".topSolution__list");

  const PANEL_ID = "topSolution-panel";

  const DATA = {
    construction: {
      problem: "複雑な原価管理・請求処理",
      items: ["現場ごとの収支管理", "請求書発行の自動化、代行"],
    },
    food: {
      problem: "シフト・勤怠・発注の連動ミス",
      items: ["変則シフトに合わせた勤怠管理", "食材発注と在庫・原価の見える化"],
    },
    realEstate: {
      problem: "契約・入金・経費の散漫な管理",
      items: ["物件別の収支・契約台帳の整備", "消費税区分に沿った記帳・レポート"],
    },
  };

  function apply(industry) {
    const d = DATA[industry];
    if (!d || !problem || !list) return;
    problem.textContent = d.problem;
    list.innerHTML = d.items.map((t) => `<li>${t}</li>`).join("");
    if (panel) {
      const active = Array.from(tabs).find((tab) => tab.dataset.industry === industry);
      if (active && active.id) {
        panel.setAttribute("aria-labelledby", active.id);
      }
    }
  }

  tabs.forEach((tab) => {
    tab.setAttribute("aria-controls", PANEL_ID);
    tab.addEventListener("click", () => {
      const industry = tab.dataset.industry;
      if (!industry || !DATA[industry]) return;
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      apply(industry);
    });
  });

  const initial = Array.from(tabs).find((t) => t.classList.contains("is-active"));
  if (initial && initial.dataset.industry && DATA[initial.dataset.industry]) {
    apply(initial.dataset.industry);
  }
  }

  const correspondenceSection = document.querySelector("#sec-correspondence");
  if (correspondenceSection) {
  const imgBase = correspondenceSection.dataset.imgBase || "";
  const coTabs = correspondenceSection.querySelectorAll(
    ".topCorrespondence__tab[data-pattern]"
  );
  const coPanel = correspondenceSection.querySelector("#topCorrespondence-panel");
  const coCard = correspondenceSection.querySelector(".topCorrespondence__card");
  const cardBg = coCard && coCard.querySelector(".topCorrespondence__cardBg");
  const photoImg = coPanel && coPanel.querySelector(".topCorrespondence__photo img");
  const titleInner = coPanel && coPanel.querySelector(".topCorrespondence__titleInner");
  const txt = coPanel && coPanel.querySelector(".topCorrespondence__txt");
  const lineImgs = coPanel
    ? coPanel.querySelectorAll(".topCorrespondence__line img")
    : [];

  const CORRESPONDENCE_PANEL_ID = "topCorrespondence-panel";

  const CORRESPONDENCE = {
    new: {
      photo: `${imgBase}pict_common_01.webp`,
      lineSvg: `${imgBase}ico_correspondence_02.svg`,
      title: [
        ["sm", "\u65b0\u898f\u4e8b\u696d\u306e"],
        ["lg", "\u7acb\u3061\u4e0a\u3052\u671f"],
        ["sm", "\u3092\u652f\u3048\u308b"],
      ],
      body:
        "\u65b0\u3057\u304f\u4e8b\u696d\u3092\u767a\u8db3\u3059\u308b\u969b\u3001\u30b3\u30a2\u696d\u52d9\u306b\u96c6\u4e2d\u3059\u308b\u305f\u3081\u306b\u306f\u3001\u5b9a\u578b\u696d\u52d9\u306e\u5207\u308a\u51fa\u3057\u304c\u4e0d\u53ef\u6b20\u3067\u3059\u3002\u696d\u52d9\u30d5\u30ed\u30fc\u306e\u69cb\u7bc9\u304b\u3089\u30a2\u30a6\u30c8\u30bd\u30fc\u30b7\u30f3\u30b0\u307e\u3067\u3001\u30ef\u30f3\u30b9\u30c8\u30c3\u30d7\u3067\u4f34\u8d70\u3057\u307e\u3059\u3002",
    },
    elite: {
      photo: `${imgBase}pict_correspondence_03.webp`,
      lineSvg: `${imgBase}ico_common_01.svg`,
      title: [
        ["sm", "EC/D2C\u306a\u3069\u306e"],
        ["lg", "\u30b9\u30e2\u30fc\u30eb\u30c1\u30fc\u30e0"],
        ["sm", "\u3092\u52a0\u901f"],
      ],
      body:
        "\u5c11\u4eba\u6570\u3067\u904b\u55b6\u3059\u308bEC\u30fbD2C\u4e8b\u696d\u3067\u306f\u3001\u30d0\u30c3\u30af\u30aa\u30d5\u30a3\u30b9\u306b\u30ea\u30bd\u30fc\u30b9\u3092\u5272\u304d\u3059\u304e\u308b\u306e\u306f\u30ea\u30b9\u30af\u3067\u3059\u3002\u300c\u5fc5\u8981\u306a\u6642\u306b\u3001\u5fc5\u8981\u306a\u7bc4\u56f2\u3060\u3051\u300d\u5916\u6ce8\u3059\u308b\u3053\u3068\u3067\u3001\u56fa\u5b9a\u8cbb\u3092\u6291\u3048\u306a\u304c\u3089\u6210\u9577\u30b9\u30d4\u30fc\u30c9\u3092\u6700\u5927\u5316\u3067\u304d\u307e\u3059\u3002",
    },
  };

  function applyCorrespondence(pattern) {
    const d = CORRESPONDENCE[pattern];
    if (!d || !coPanel || !photoImg || !titleInner || !txt) return;

    photoImg.src = d.photo;
    txt.textContent = d.body;
    titleInner.innerHTML = d.title
      .map(
        ([size, label]) =>
          `<span class="topCorrespondence__lbl topCorrespondence__lbl--${size}">${label}</span>`
      )
      .join("");

    lineImgs.forEach((img) => {
      img.src = d.lineSvg;
    });

    coPanel.classList.toggle("topCorrespondence__cardBody--elite", pattern === "elite");
    if (cardBg) {
      cardBg.classList.toggle("topCorrespondence__cardBg--flip", pattern === "elite");
    }

    const activeTab = Array.from(coTabs).find((t) => t.dataset.pattern === pattern);
    if (activeTab && activeTab.id) {
      coPanel.setAttribute("aria-labelledby", activeTab.id);
    }
  }

  coTabs.forEach((tab) => {
    tab.setAttribute("aria-controls", CORRESPONDENCE_PANEL_ID);
    tab.addEventListener("click", () => {
      const pattern = tab.dataset.pattern;
      if (!pattern || !CORRESPONDENCE[pattern]) return;
      coTabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      applyCorrespondence(pattern);
    });
  });

  const initialCo = Array.from(coTabs).find((t) => t.classList.contains("is-active"));
  if (initialCo && initialCo.dataset.pattern && CORRESPONDENCE[initialCo.dataset.pattern]) {
    applyCorrespondence(initialCo.dataset.pattern);
  }
  }

  const reasonList = document.querySelector("#sec-reason .topReasonList");
  if (reasonList) {
    const items = reasonList.querySelectorAll(".topReasonList__item");
    items.forEach((item) => {
      const hit = item.querySelector(".topReasonList__hit");
      if (!hit) return;

      hit.addEventListener("click", () => {
        const willOpen = !item.classList.contains("is-open");
        items.forEach((other) => {
          const oHit = other.querySelector(".topReasonList__hit");
          const on = other === item && willOpen;
          other.classList.toggle("is-open", on);
          if (oHit) {
            oHit.setAttribute("aria-expanded", on ? "true" : "false");
          }
        });
      });
    });
  }

  const topFlowRoot = document.querySelector("[data-top-flow]");
  if (topFlowRoot && typeof Swiper !== "undefined") {
    const swiperEl = topFlowRoot.querySelector(".topFlow__swiper");
    if (swiperEl) {
    const steps = topFlowRoot.querySelectorAll(".topFlow__step");
    const hits = topFlowRoot.querySelectorAll(".topFlow__hit");
    const segs = topFlowRoot.querySelectorAll(".topFlow__lineSeg");
    const panel = topFlowRoot.querySelector("#topFlow-swiper");

    function applyFlowIndex(i) {
      steps.forEach((step, idx) => {
        const on = idx === i;
        step.classList.toggle("is-active", on);
        const b = step.querySelector(".topFlow__hit");
        if (b) {
          b.setAttribute("aria-selected", on ? "true" : "false");
        }
      });
      segs.forEach((seg, idx) => {
        seg.classList.toggle("is-active", idx === i && i < 3);
      });
      const tab = topFlowRoot.querySelector("#topFlow-tab-" + i);
      if (panel && tab && tab.id) {
        panel.setAttribute("aria-labelledby", tab.id);
      }
    }

    const flowSwiper = new Swiper(swiperEl, {
      speed: 400,
      spaceBetween: 0,
      resistanceRatio: 0.85,
      on: {
        slideChange() {
          applyFlowIndex(flowSwiper.activeIndex);
        },
      },
    });

    hits.forEach((btn, idx) => {
      btn.addEventListener("click", () => {
        flowSwiper.slideTo(idx);
      });
    });

    applyFlowIndex(flowSwiper.activeIndex);
    }
  }
});
